import React, { FC } from 'react'
import {
    StyledBreadcrumbLink,
    StyledChevron,
    StyledDayLink,
    StyledDayText,
    StyledPublication,
    StyledPublicationLink,
    StyledPublicationList,
    StyledSiteMapBreadcrumb,
    StyledSiteMapDay,
    StyledSiteMapDayList,
} from '../SiteMap.styled'
import {
    SiteMapMonthV4DTO,
    SiteMapPublicationV4DTO,
} from '@west-australian-newspapers/publication-types'

interface SiteMapMonthDayProps {
    siteMapIndex: SiteMapMonthV4DTO | SiteMapPublicationV4DTO
}

export const SiteMapMonthDays: FC<SiteMapMonthDayProps> = ({
    siteMapIndex,
}) => {
    const { indexType, year, month, days } = siteMapIndex
    const isDayIndex =
        indexType === 'day' && siteMapIndex.publications.length > 0
    // Link to the first day of the month by default
    const firstDayPath =
        isDayIndex && siteMapIndex.days.length > 0
            ? `/${siteMapIndex.days[0]}`
            : ''
    return (
        <>
            <StyledSiteMapBreadcrumb>
                <StyledBreadcrumbLink to="/sitemap">Year</StyledBreadcrumbLink>
                <StyledChevron />
                <StyledBreadcrumbLink to="/sitemap">
                    {year}
                </StyledBreadcrumbLink>
                <StyledChevron />
                <StyledBreadcrumbLink
                    to={`/sitemap/${year}/${month}${firstDayPath}`}
                >
                    {new Intl.DateTimeFormat('en-US', { month: 'long' }).format(
                        new Date(0, month - 1),
                    )}
                </StyledBreadcrumbLink>
                {isDayIndex && (
                    <>
                        <StyledChevron />
                        <StyledBreadcrumbLink
                            to={`/sitemap/${year}/${month}/${siteMapIndex.currentDay}`}
                        >
                            {siteMapIndex.currentDay}
                        </StyledBreadcrumbLink>
                    </>
                )}
            </StyledSiteMapBreadcrumb>
            <StyledSiteMapDayList>
                {days.map((day) => {
                    const isActive =
                        isDayIndex && day === siteMapIndex.currentDay
                    return (
                        <StyledSiteMapDay key={day} isActive={isActive}>
                            {isActive ? (
                                <StyledDayText>{day}</StyledDayText>
                            ) : (
                                <StyledDayLink
                                    to={`/sitemap/${year}/${month}/${day}`}
                                >
                                    {day}
                                </StyledDayLink>
                            )}
                        </StyledSiteMapDay>
                    )
                })}
            </StyledSiteMapDayList>
            {isDayIndex && (
                <StyledPublicationList>
                    {siteMapIndex.publications.map((p) => (
                        <StyledPublication key={p.id}>
                            <StyledPublicationLink to={new URL(p.url).pathname}>
                                {p.heading}
                            </StyledPublicationLink>
                        </StyledPublication>
                    ))}
                </StyledPublicationList>
            )}
        </>
    )
}
